import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";

function DeleteInvoice({ onClose , id, invoice_id, final }) {
    const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
    const { setGlobalLoading, token } = useOutletContext();
    const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const [data, setData] = useState([]);

  const onSubmit = async (data) => {
    if(!id && !invoice_id && !final){
        return
    }
    try {
      setGlobalLoading(true);
     
      const response = await axios.post(
        `${API_BASE_URL}/orders/delete_invoice`,
        {
            comments :data.comments,
            id:id,
            invoice_id:invoice_id,
            final:final
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
         },
        }
      );
      toastr.success("IInvoice deleted successfully!");
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
    }; 

  return (
    <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog  modal-md" role="document" style={{ maxWidth: "500px" }}>
            <div className="modal-content">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="modal-header">
                        <h4 className="modal-title">Delete Invoice</h4>
                        <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="ti ti-x"></i>
                        </button>
                    </div>
                    <div className="modal-body row" style={{ textAlign: "left" }}>
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="mb-2">
                                    <label className="form-label">Reason for deletion *</label>
                                    <input type="text" {...register("comments", { required: "required"})} className={`form-control ${ errors.comments && "is-invalid"}`} />             
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-2">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  );  
}

export default DeleteInvoice;